export default "__VITE_ASSET__CeSQcq6k__"